export enum EAssignerType {
  digital = 'digital',
  legal = 'legal',
  finance = 'finance'
}